import { clearAppActiveContext } from 'src/api/appActiveContext';
import { IMPERSONATED_KEY } from 'src/constants/sessionStorage';

export type ImpersonationBootstrapStorage = Pick<Storage, 'getItem' | 'removeItem' | 'setItem'>;

const getSearchParams = (search: string): URLSearchParams => {
    const normalizedSearch = search.startsWith('?') ? search : `?${search}`;
    return new URLSearchParams(normalizedSearch);
};

export const getImpersonationFromSearch = (search: string): string | null => {
    const impersonate = getSearchParams(search).get('impersonate')?.trim();

    if (!impersonate || impersonate === 'undefined') {
        return null;
    }

    return impersonate;
};

export const bootstrapImpersonationFromSearch = ({
    search,
    storage,
}: {
    search: string;
    storage: ImpersonationBootstrapStorage;
}): string | null => {
    const searchParams = getSearchParams(search);
    const impersonateValue = searchParams.get('impersonate');
    const impersonate = impersonateValue?.trim();

    if (!impersonate) {
        if (searchParams.has('impersonate')) {
            storage.removeItem(IMPERSONATED_KEY);
            clearAppActiveContext(storage);
        }
        return null;
    }

    if (impersonate === 'undefined') {
        storage.removeItem(IMPERSONATED_KEY);
        clearAppActiveContext(storage);
        return null;
    }

    if (storage.getItem(IMPERSONATED_KEY) !== impersonate) {
        clearAppActiveContext(storage);
    }
    storage.setItem(IMPERSONATED_KEY, impersonate);
    return impersonate;
};

export const bootstrapWindowImpersonation = (): string | null => {
    if (typeof window === 'undefined') {
        return null;
    }

    try {
        return bootstrapImpersonationFromSearch({
            search: window.location.search,
            storage: window.sessionStorage,
        });
    } catch {
        return null;
    }
};
